/**
 * mwApp.channels module <br>
 * Work with channels: show/add/edit/remove
 *
 * @namespace mwApp/channels
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/channels
 * @see mwApp/channels
 *
 * @ngdoc config
 * @name mwApp/channels.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * abstract state for /channels
     */
    .state('app.channels', {
      abstract: true,
      url: '/channels',
      template: '<ui-view/>'
    })

    /**
     * controller {@link mwApp/channels.controller:ChannelsCtrl}
     * @name /channels
     * @memberof mwApp/channels.config:ConfigRoutes
     */
    .state('app.channels.list', {
      url: '',
      templateUrl: 'components/channels/views/channels.html',
      controller: 'ChannelsCtrl as vm',
      label: 'Channels',
      access: 'viewChannel'
    })

    /**
     * abstract state for /channels/:channelId
     */
    .state('app.channels.channel', {
      abstract: true,
      url: '/:channelId',
      template: '<ui-view/>',
      resolve: {
        extra: /* @ngInject */ function ($transition$, ChannelDTO) {
          const { channelId: id } = $transition$.params()
          return ChannelDTO.loadExtra(ChannelDTO.extraFor({ id: +id || 0 }))
        },
        chnl: /* @ngInject */ function ($transition$, ChannelDTO) {
          const { channelId: id } = $transition$.params()
          return +id ? ChannelDTO.load({ id }) : new ChannelDTO()
        },
        serviceExtra: /* @ngInject */ function ($transition$, chnl) {
          return !chnl._isNew() ? chnl._loadServices() : null
        },
        allNetworksById: /* @ngInject */function (extra, chnl) {
          const networks = [...extra.networks, ...chnl.networks]
          return networks.reduce((acc, item) => Object.assign(acc, { [item.id]: item }), {})
        }
      }
    })

    /**
     */
    .state('app.channels.channel.edit', {
      url: '',
      views: {
        '': {
          templateUrl: 'components/channels/views/addChannel.html',
          controller: 'AddChannelCtrl as vm'
        },
        'catchUpsService@app.channels.channel.edit': {
          templateUrl: 'components/channels/views/catchUpsService.html',
          controller: 'CatchupCtrl as vm'
        },
        'liveRewindService@app.channels.channel.edit': {
          templateUrl: 'components/channels/views/liveRewindService.html',
          controller: 'LiveRewindCtrl as vm'
        }
      },
      resolve: {
        catchups: /* @ngInject */ function ($transition$, serviceExtra) {
          return serviceExtra ? serviceExtra.catchups : []
        },
        liveRewinds: /* @ngInject */ function ($transition$, serviceExtra) {
          return serviceExtra && serviceExtra.liveRewind ? [serviceExtra.liveRewind] : []
        },
        scope: function () {
          // use object 'scope' to share object between different views
          return {}
        }
      },
      label: '{{::channelId | addOrEdit}} Channel',
      access: ':channelId (+) ! IF createChannel ELSE editChannel'
    })

    /**
     */
    .state('app.channels.channel.contentSets', {
      url: '/contentSets',
      templateUrl: 'components/common/components/assignContentSets/assignContentSets.html',
      controller: 'AssignContentSetsCtrl as vm',
      label: 'Edit Content Sets',
      resolve: {
        contentItem: /* @ngInject */ function ($transition$, ChannelDTO) {
          const { channelId: id } = $transition$.params()
          return +id ? ChannelDTO.load({ id }) : new ChannelDTO()
        },

        allContentSets: /* @ngInject */ function (ChannelDTO, chnl) {
          return ChannelDTO.loadAvailableContentSets(chnl)
        }
      }
    })
}
